import { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
interface FaqData {
  id: number;
  icon?: string | null;
  question: string;
  answer: string;
}

interface Props {
  faqData: FaqData[] | undefined; // The faqData prop must be an array of FaqData objects
}
const PackageAccordion: React.FC<Props> = ({ faqData }) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const handleToggle = (key: string) => {
    setActiveKey(activeKey === key ? null : key);
  };

  useEffect(() => {
    import("./PackageAccordian.css");
  }, []);

  return (
    <>
      <Accordion activeKey={activeKey}>
        {faqData?.map((faq, index) => (
          <Card key={index} className="faq-card">
            <Card.Header className="p-0 px-md-1">
              <Accordion.Button
                as="div"
                className="faq-toggle gap-3"
                onClick={() => handleToggle(index.toString())}
                aria-expanded={activeKey === index.toString()}
              >
                {faq.icon && (
                  <span>
                    <img src={faq.icon} alt={faq.question} />
                  </span>
                )}
                <h3
                  className="mb-0 font-16 ff-bold faq-question"
                  dangerouslySetInnerHTML={{
                    __html: faq?.question ?? "",
                  }}
                ></h3>
                <span className="faq-icon">
                  <img
                    src={
                      activeKey === index.toString()
                        ? "https://goodhand.b-cdn.net/Assets/cart/open.svg"
                        : "https://goodhand.b-cdn.net/Assets/cart/close.svg"
                    }
                    alt="Step icon"
                  />
                </span>
              </Accordion.Button>
            </Card.Header>
            <Accordion.Collapse eventKey={index.toString()}>
              <p
              
                dangerouslySetInnerHTML={{
                  __html: faq?.answer ?? "",
                }}
              ></p>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </>
  );
};

export default PackageAccordion;
